import { User } from "../entities/User";
import { Operations } from "../services/api/api";
import { Image } from "../services/shirts/types";

export interface Dictionary<T> {
  [Key: string]: T;
}

export interface CustomParamValue<T> {
  value: T;
  operation: Operations;
}

export interface CustomParam<T> {
  [Key: string]: CustomParamValue<T>;
}

export enum EXTRA_DATA {
  MATCH_WORN = "match-worn",
  MATCH_ISSUED = "match-issued",
  CUSTOM_TEXT = "text",
  CUSTOM_NUMBER = "number",
  SIZE = "size",
}

export const EXTRA_DATA_TYPES: Record<EXTRA_DATA, string> = {
  [EXTRA_DATA.MATCH_WORN]: "ExtraDataMatch",
  [EXTRA_DATA.MATCH_ISSUED]: "ExtraDataMatch",
  [EXTRA_DATA.CUSTOM_TEXT]: "none",
  [EXTRA_DATA.CUSTOM_NUMBER]: "none",
  [EXTRA_DATA.SIZE]: "none",
};

export interface LegitCheckRole {
  id: number;
  name: string;
}
export interface LegitCheckUser {
  id: number;
  username: string;
  email: string;
  role: LegitCheckRole;
  profile_image: Image;
  shirt_count: number;
}
export interface LegitCheckItem {
  id: number;
  is_legit: boolean;
  comment: string;
  user: LegitCheckUser;
  item_id: number;
}
